module.exports = __webpack_public_path__ + "fonts/matrix-book.bde92a59.ttf";